/*
 *   File : overlay.js
 *   Author : https://evoqins.com
 *   Description :  Modal open overlay
 *   Integrations : NA
 *   Version : 1.0.0
*/

// custom packages
import React, { memo } from 'react';

const OverLay = ({ isOpen, onClose, children, className, ref, dismiss }) => {
    return (
        isOpen &&
        <div ref={ref} className={`${className} overlay-background z-2`} onClick={onClose} data-bs-dismiss={dismiss}>
            <div className='overlay-container' >
                {children}
            </div >
        </div >
    );
};

export default memo(OverLay);